import React from "react";

/**
 * Format a number as USD currency.
 */
function formatCurrency(value) {
    const num = parseFloat(value);
    if (isNaN(num)) return "$0.00";
    return num.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
    });
}

const InvoiceSection = ({ invoice, lineItems }) => {
    if (!invoice) return null;

    const items = lineItems || invoice.line_items || [];
    const subtotal = items.reduce((sum, item) => {
        return sum + (parseFloat(item.quantity) || 0) * (parseFloat(item.unit_price) || 0);
    }, 0);
    const tax = parseFloat(invoice.tax_amount) || 0;
    const total = subtotal + tax;

    return (
        <div className="invoice-section">
            <div className="invoice-section__header">
                <h4 className="invoice-section__title">Invoice</h4>
                {invoice.invoice_number && (
                    <span className="invoice-section__number">#{invoice.invoice_number}</span>
                )}
            </div>

            <div className="invoice-section__table-wrap">
                <table className="invoice-section__table">
                    <thead>
                        <tr>
                            <th className="invoice-section__th">Item</th>
                            <th className="invoice-section__th invoice-section__th--desc">Description</th>
                            <th className="invoice-section__th invoice-section__th--num">Qty</th>
                            <th className="invoice-section__th invoice-section__th--num">Unit Price</th>
                            <th className="invoice-section__th invoice-section__th--num">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, idx) => {
                            const qty = parseFloat(item.quantity) || 0;
                            const price = parseFloat(item.unit_price) || 0;
                            const lineTotal = qty * price;
                            return (
                                <tr key={item.id || idx} className="invoice-section__row">
                                    <td className="invoice-section__td">
                                        {item.product_name}
                                        {item.weight_unit && (
                                            <span className="invoice-section__unit"> ({item.weight_unit})</span>
                                        )}
                                    </td>
                                    <td className="invoice-section__td invoice-section__td--desc">
                                        {item.description || "—"}
                                    </td>
                                    <td className="invoice-section__td invoice-section__td--num">{qty}</td>
                                    <td className="invoice-section__td invoice-section__td--num">{formatCurrency(price)}</td>
                                    <td className="invoice-section__td invoice-section__td--num">{formatCurrency(lineTotal)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="invoice-section__totals">
                <div className="invoice-section__total-row">
                    <span>Subtotal</span>
                    <span>{formatCurrency(subtotal)}</span>
                </div>
                {tax > 0 && (
                    <div className="invoice-section__total-row">
                        <span>Tax</span>
                        <span>{formatCurrency(tax)}</span>
                    </div>
                )}
                <div className="invoice-section__total-row invoice-section__total-row--grand">
                    <span>Total</span>
                    <span>{formatCurrency(total)}</span>
                </div>
            </div>

            {invoice.notes && (
                <div className="invoice-section__notes">
                    <span className="invoice-section__notes-label">Notes</span>
                    <p className="invoice-section__notes-text">{invoice.notes}</p>
                </div>
            )}
        </div>
    );
};

export default InvoiceSection;
